import React, { useEffect, useMemo, useRef, useState } from "react";
import Check from "./Check";
import wizard_css from "../../inspection.module.css";
import CheckTitle from "./CheckTitle";

export default function CheckOptions({
  check,
  equipment,
  topLevel,
  tosubequipmentinspection,
  station,
  data,
  set_data,
  saveTextCommentAndPhoto,
  deleteComment,
  index,
  setCheckValue,
  type,
  addInterceptor,
  params,
}) {
  const checkRef = useRef();
  const [show_more, set_show_more] = useState(false);

  const check_options = useMemo(() => {
    if (check.options && check.title === "Nozzle Fueling Pressure") {
      let not_options = check.options.filter(
        (x) => x.label.indexOf("Not") === -1
      );

      const over_option_index = check.options.findIndex(
        (x) => x.label.indexOf("Over 50") !== -1
      );

      if (over_option_index === -1) {
        return not_options;
      }

      if (
        show_more ||
        check.locked ||
        check.options[over_option_index].disabled
      ) {
        not_options.splice(over_option_index, 1);
        return not_options;
      }

      return not_options.slice(0, 52);
    } else {
      return check.options;
    }
  }, [check.locked, check.options, check.title, show_more]);

  useEffect(() => {
    window.$(checkRef.current).popover();
  }, []);

  return (
    <>
      {!check.metadata?.hideLabel && check.metadata?.widget !== "fdp" && (
        <CheckTitle
          title={check.title}
          check={check}
          equipment={equipment}
          station={station}
        ></CheckTitle>
      )}
      {check.metadata?.widget === "fdp" && <h2>{check.title}</h2>}

      <div className="clearfix">
        {check_options &&
          check_options.map(
            (option) =>
              (!option.hidden &&
                (check.metadata?.widget !== "fdp" ||
                  (check.metadata?.widget === "fdp" &&
                    ((equipment.dpGaugeType !== "go_no_go" &&
                      option.valueName !== "G" &&
                      option.valueName !== "R") ||
                      (equipment.dpGaugeType === "go_no_go" &&
                        (option.valueName === "G" ||
                          option.valueName === "R"))))) && (
                  <div className={wizard_css["options"]} key={option.value}>
                    <div>
                      {!!option.critical && (
                        <small className="bg-danger">oos</small>
                      )}
                    </div>
                    <label
                      className={`btn btn-default ${
                        check.locked && "" + check.value === "" + option.value
                          ? "btn-danger"
                          : ""
                      }`}
                    >
                      <span>{option.label}</span>{" "}
                      {!check.locked && !option.disabled && (
                        <input
                          type="radio"
                          value={option.value}
                          checked={"" + check.value === "" + option.value}
                          name={
                            topLevel
                              ? "index_" + index
                              : "child_index_" + check.id
                          }
                          onChange={() =>
                            option.label.indexOf("Over 50") === -1
                              ? setCheckValue(option.value, check.id, topLevel)
                              : set_show_more(true)
                          }
                        />
                      )}
                    </label>
                  </div>
                )) ||
              false
          )}
      </div>
      {check.options &&
        check.options.map(
          (option) =>
            !option.hidden && (
              <div className="option clearfix" key={option.value}>
                {"" + check.value === "" + option.value && (
                  <div className={`${wizard_css["sub-checks"]} clearfix`}>
                    {option.children.map((child, child_index) => (
                      <Check
                        key={child_index}
                        check={child}
                        equipment={equipment}
                        topLevel={false}
                        tosubequipmentinspection={tosubequipmentinspection}
                        station={station}
                        data={data}
                        set_data={set_data}
                        saveTextCommentAndPhoto={saveTextCommentAndPhoto}
                        deleteComment={deleteComment}
                        index={index}
                        setCheck={setCheckValue}
                        addInterceptorValue={addInterceptor}
                        type={type}
                        params={params}
                        className="check" // TODO CHECK
                      ></Check>
                    ))}
                  </div>
                )}
              </div>
            )
        )}
    </>
  );
}
